import { Check, Minus } from "lucide-react";
import { useApp } from "@/lib/i18n";

export const ROLE_LABEL = { owner: ["Pemilik", "Owner"], admin: ["Admin", "Admin"], editor: ["Editor", "Editor"], member: ["Ahli", "Member"], viewer: ["Pemerhati", "Viewer"] };
const COLS = ["viewer", "member", "editor", "admin", "owner"];
const ROWS = [
  [["Lihat mesyuarat, transkrip & dokumen pasukan", "View team meetings, transcripts & documents"], [1, 1, 1, 1, 1]],
  [["Muat turun & eksport", "Download & export"], [1, 1, 1, 1, 1]],
  [["Rakam, muat naik & hantar bot", "Record, upload & send bot"], [0, 1, 1, 1, 1]],
  [["Sunting mesyuarat & dokumen sendiri", "Edit own meetings & documents"], [0, 1, 1, 1, 1]],
  [["Sunting semua mesyuarat pasukan", "Edit all team meetings"], [0, 0, 1, 1, 1]],
  [["Lihat mesyuarat peribadi ahli lain", "See other members' private meetings"], [0, 0, 0, 1, 1]],
  [["Jemput, tukar peranan & keluarkan ahli", "Invite, change roles & remove members"], [0, 0, 0, 1, 1]],
  [["Padam mana-mana mesyuarat", "Delete any meeting"], [0, 0, 0, 1, 1]],
  [["Urus langganan & tambah kuota", "Manage plan & top-ups"], [0, 0, 0, 1, 1]],
];

export const RoleMatrix = () => {
  const { L } = useApp();
  return (
    <div className="mt-3 overflow-x-auto" data-testid="role-matrix">
      <table className="w-full min-w-[560px] text-sm">
        <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-500"><th className="py-2 pr-3 font-semibold">{L("Kebenaran", "Permission")}</th>{COLS.map((c) => <th key={c} className="px-2 py-2 text-center font-semibold">{L(...ROLE_LABEL[c])}</th>)}</tr></thead>
        <tbody className="divide-y divide-slate-100">
          {ROWS.map(([label, vals]) => (
            <tr key={label[0]}><td className="py-2 pr-3">{L(...label)}</td>{vals.map((v, i) => <td key={COLS[i]} className="px-2 py-2 text-center">{v ? <Check size={15} className="mx-auto text-emerald-600" /> : <Minus size={15} className="mx-auto text-slate-300" />}</td>)}</tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
